import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=54973796&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=54973796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54973796",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavLinks: require('/home/circleci/repo/components/nav/NavLinks.vue').default,NavLinks: require('/home/circleci/repo/components/nav/NavLinks.vue').default,SearchFranchises: require('/home/circleci/repo/components/SearchFranchises.vue').default})
